export const isFileTypeAllowed = (file, allowedTypes) => {
	const mimeType = file.type || '';
	for (const allowedType of allowedTypes) {
		if (mimeType === allowedType) {
			return true;
		}
		if (allowedType.endsWith('/*')) {
			const prefix = allowedType.split('/')[0];
			if (mimeType.startsWith(`${prefix}/`)) {
				return true;
			}
		}
	}
	return false;
};

export const validateFile = (file, config, i18n) => {
	const maxSizeBytes = Number(config.maxFilesize || 50) * 1024 * 1024;
	if (file.size > maxSizeBytes) {
		return { error: true, message: config.invalidMessage || i18n.fileTooLarge || 'File is too large' };
	}

	if (Boolean(config.restrictFileTypes) && Array.isArray(config.allowedTypes) && config.allowedTypes.length > 0) {
		if (!isFileTypeAllowed(file, config.allowedTypes)) {
			return { error: true, message: config.invalidMessage || i18n.invalidFileType || 'Invalid file type' };
		}
	}

	return { error: false };
};
